import { useEffect, useState } from 'react';
import { MultiplexedChannel } from 'infrastructure/t4/ChannelResolver/MultiplexedChannel';
import { StreamSelector } from 'infrastructure/t4/ChannelResolver/streamSelector';
import { StreamSelector as StreamSelectorV2 } from 'infrastructure/t4/ChannelResolver/streamSelectorV2';

const STATS_POLLING_INTERVAL_MSEC = 500;

export function useSelectedStreamIndex(channel: MultiplexedChannel, options: { useV2: boolean, debug: boolean }) {
    const { useV2, debug } = options;
    const debugTag = debug ? channel.mediaDeviceId : undefined;

    const [selectedIndex, set] = useState(0);

    useEffect(() => {
        if (!channel) return;

        const streamSelector = useV2 ? new StreamSelectorV2(channel.channels.length, debugTag) : new StreamSelector();

        const interval = setInterval(async () => {
            try {
                const stats = await Promise.all(channel.channels.map(ch => ch.getStats()));
                streamSelector.push(...stats);
                set(streamSelector.getTargetStreamIndex());
            } catch (e) {
                // console.error(`error while getting stats report: ${e}`);
                // TODO: error handling
            }
        }, STATS_POLLING_INTERVAL_MSEC);

        return () => clearInterval(interval);
    }, [channel, useV2, debugTag]);

    return selectedIndex;
}
